import { ExternalInvitation } from '@/domain/external-invitation/entities/external-invitation.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

export type Params = {
  projectId: number;
};

export type GetExternalInvitationsResult = ExternalInvitation[];

export const getExternalInvitations = createAppAsyncThunk(
  'externalInvitation/getExternalInvitations',
  async (
    params: Params,
    { extra: { externalInvitationGateway, snackbarGateway } },
  ): Promise<GetExternalInvitationsResult> => {
    try {
      return await externalInvitationGateway.getInvitations(params.projectId);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetExternalInvitations.Message.error'));
}
